import { render, staticRenderFns } from "./AlertConfigs.vue?vue&type=template&id=39dd03de"
import script from "./AlertConfigs.vue?vue&type=script&lang=js"
export * from "./AlertConfigs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports